import { Box, BoxProps, ClickAwayListener } from '@mui/material'
import {
  ElementType,
  MutableRefObject,
  ReactNode,
  useRef,
  useState,
  VFC,
} from 'react'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { useLocale } from 'providers/LocaleProvider'

interface CalendarProps extends BoxProps {
  value: Date | null
  handleChange: (value: Date, keyboardInputValue?: string | undefined) => void
  ariaLabel: string
  selectBtn: ElementType
  id?: string
  label?: string | ReactNode
  inputWidth?: string
  disablePast?: boolean
}

const Calendar: VFC<CalendarProps> = ({
  selectBtn: SelectBtn,
  value,
  handleChange,
  sx,
  ariaLabel,
  id,
  label,
  inputWidth,
  disablePast,
}) => {
  const [open, setOpen] = useState(false)
  const customInputRef = useRef() as MutableRefObject<HTMLInputElement>
  const handleDateSelect = (value: Date) => {
    handleChange(value)
    setOpen(false)
  }
  const { selectedLocale } = useLocale()
  return (
    <LocalizationProvider
      dateAdapter={AdapterDateFns}
      adapterLocale={selectedLocale}>
      <ClickAwayListener onClickAway={() => setOpen(false)}>
        <Box
          sx={{
            position: 'relative',
            ...sx,
          }}>
          <DatePicker
            open={open}
            getOpenDialogAriaText={() => ariaLabel || ''}
            value={value}
            PopperProps={{ anchorEl: customInputRef.current }}
            onChange={(value) => handleDateSelect(value as Date)}
            disablePast={disablePast}
            renderInput={({ inputProps, disabled, onChange, value: date }) => (
              <div ref={customInputRef}>
                <SelectBtn
                  width={inputWidth}
                  disabled={disabled}
                  open={open}
                  setOpen={setOpen}
                  date={date}
                  onChange={onChange}
                  inputProps={inputProps}
                  value={value}
                  id={id}
                  label={label}
                />
              </div>
            )}
          />
        </Box>
      </ClickAwayListener>
    </LocalizationProvider>
  )
}

export default Calendar
